'use strict';

const SELECTOR = '.donation-panel';

export function init() {
    const customAmountInput = document.getElementById('custom_amount');

    document.querySelectorAll(SELECTOR).forEach(element => {
        element.querySelector('#other').addEventListener('click', () => {
            element.querySelector('.donation-panel__specific-amount').classList.add('hidden');
            element.querySelector('.donation-panel__other-amount').classList.remove('hidden');

            element.querySelector('#custom_amount').tabIndex = 0;
            element.querySelector('#custom_amount').focus();

            element.querySelectorAll('[type="radio"]').forEach(radio => {
                radio.required = false;
            });

            element.querySelector('[type="number"]').required = true;
        });


        element.addEventListener('submit', event => {
            event.preventDefault();

            const cid = event.target.dataset.contribution;
            let amount = event.target.amount.value;

            // const ct = event.target.ct.value;
            if(customAmountInput.value > 0) {
                amount = customAmountInput.value;
            }

            if(!cid) {
                return;
            }

            if (!amount) {
                return alert('Please select a donation amount');
            }

            // const url = new URL(event.target.action);
            // // url.searchParams.set('amount', amount);
            // // url.searchParams.set('ct', ct);

            window.location.href = `${event.target.action}${cid}/add-to-basket/${amount}`;
        });
    });
}
